<template>
  <div class="d-flex align-center ga-2">
    <v-progress-linear :model-value="percent" :color="barColor" height="7" rounded bg-color="grey-lighten-3" class="flex-grow-1" style="min-width: 60px" />
    <span v-if="showValue" class="text-caption text-medium-emphasis qa-bar-value">{{ valueText }}</span>
  </div>
</template>

<script>
import { ratioColor } from '@/utils/qaScoring';

export default {
  name: 'QaBar',
  props: {
    /** 0–100 */
    percent: { type: Number, required: true },
    showValue: { type: Boolean, default: true },
    valueText: { type: String, default: '' },
    color: { type: String, default: '' },
  },
  computed: {
    barColor() {
      return this.color || ratioColor(this.percent / 100);
    },
  },
};
</script>

<style scoped>
.qa-bar-value {
  font-variant-numeric: tabular-nums;
  min-width: 38px;
  text-align: right;
}
</style>
